module.exports = __webpack_public_path__ + "static/media/shape2.14897bbe.svg";